module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "silkenbook"
  }, [_vm._v("contents")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('ol', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('li', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "s2"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 1")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("Seek INSPIRATION")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 2")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("Find your PERSONAL STYLE")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 3")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("IDENTIFY your project")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 4")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("PREP your space")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 5")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("DRAW UP your space")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 6")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("Translate your IDEAS")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 7")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("FINALIZE your scheme")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s1"
  }, [_vm._v("STEP 8")]), _c('br'), _c('span', {
    staticClass: "s2"
  }, [_vm._v("Happy DECORATING")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/final",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s2"
  }, [_vm._v("Final Words")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/directory",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s2"
  }, [_vm._v("Directory")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/photocredits",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s2"
  }, [_vm._v("Photo Credits")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s2"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "s2"
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0